import { render } from "./ManualLinkModal.vue?vue&type=template&id=6c42b577&ts=true"
import script from "./ManualLinkModal.vue?vue&type=script&lang=ts"
export * from "./ManualLinkModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__